/**
 * Product suggestions configuration
 * Maps stone IDs to product categories and URLs on lithae.com/shop
 * With real product images from the Lithae shop
 */

// Product types based on user's usage preference
export const PRODUCT_TYPES = {
  sur_soi: {
    label: "À porter sur vous",
    description: "Bijoux et pierres de poche",
    categories: ["bracelet", "collier", "pendentif", "pierre_roulee"]
  },
  maison: {
    label: "Pour votre intérieur",
    description: "Pierres décoratives et énergétiques",
    categories: ["druse", "a_poser", "sphere", "geode", "pierre_brute"]
  },
  meditation: {
    label: "Pour méditer",
    description: "Pierres de méditation et de connexion",
    categories: ["sphere", "pierre_roulee", "galet", "pointe"]
  },
  table_de_nuit: {
    label: "Pour votre table de nuit",
    description: "Pierres apaisantes pour le sommeil",
    categories: ["pierre_roulee", "galet", "coeur", "druse"]
  }
};

// Stone products mapping with REAL product images from Lithae shop
export const STONE_PRODUCTS = {
  amethyste: {
    name: "Améthyste",
    shopFilterUrl: "https://www.lithae.com/shop?search=amethyste",
    products: {
      bracelet: {
        name: "Bracelet Améthyste 8mm",
        url: "https://www.lithae.com/shop/bbat8-bracelet-amethyste-8mm-96",
        imageUrl: "https://www.lithae.com/web/image/product.product/98/image_1024/%5BBBAT8%5D%20Bracelet%20Am%C3%A9thyste%208mm",
        type: "Bracelet"
      },
      collier: {
        name: "Collier Doré Améthyste",
        url: "https://www.lithae.com/shop/collier-dore-amethyste-308",
        imageUrl: "https://www.lithae.com/web/image/product.product/367/image_1024/Collier%20Dor%C3%A9%20Am%C3%A9thyste",
        type: "Collier"
      },
      pierre_roulee: {
        name: "Améthyste Pierre Roulée",
        url: "https://www.lithae.com/shop/pprat-amethyste-pierre-roulee-176",
        imageUrl: "https://www.lithae.com/web/image/product.product/210/image_1024/%5BPPRAT%5D%20Am%C3%A9thyste%20Pierre%20Roul%C3%A9e",
        type: "Pierre roulée"
      },
      druse: {
        name: "Améthyste Druse",
        url: "https://www.lithae.com/shop/pbdat11-amethyste-druse-174",
        imageUrl: "https://www.lithae.com/web/image/product.product/208/image_1024/%5BPBDAT11%5D%20Amethyste%20Druse",
        type: "Druse"
      },
      pendentif: {
        name: "Collier Naya Améthyste",
        url: "https://www.lithae.com/shop/collier-naya-amethyste-326",
        imageUrl: "https://www.lithae.com/web/image/product.product/389/image_1024/Collier%20Naya%20Am%C3%A9thyste",
        type: "Pendentif"
      }
    }
  },
  "quartz-rose": {
    name: "Quartz Rose",
    shopFilterUrl: "https://www.lithae.com/shop?search=quartz+rose",
    products: {
      bracelet: {
        name: "Bracelet Quartz Rose 8mm",
        url: "https://www.lithae.com/shop/bracelet-quartz-rose-8mm-265",
        imageUrl: "https://www.lithae.com/web/image/product.product/324/image_1024/Bracelet%20Quartz%20Rose%208mm",
        type: "Bracelet"
      },
      collier: {
        name: "Collier Doré Quartz Rose",
        url: "https://www.lithae.com/shop/collier-dore-quartz-rose-281",
        imageUrl: "https://www.lithae.com/web/image/product.product/340/image_1024/Collier%20Dor%C3%A9%20Quartz%20Rose",
        type: "Collier"
      },
      coeur: {
        name: "Quartz Rose Cœur",
        url: "https://www.lithae.com/shop/ppcqr15-quartz-rose-coeur-253",
        imageUrl: "https://www.lithae.com/web/image/product.product/311/image_1024/%5BPPCQR15%5D%20Quartz%20Rose%20Coeur",
        type: "Cœur"
      },
      pierre_roulee: {
        name: "Quartz Rose Cœur",
        url: "https://www.lithae.com/shop/ppcqr14-quartz-rose-coeur-252",
        imageUrl: "https://www.lithae.com/web/image/product.product/310/image_1024/%5BPPCQR14%5D%20Quartz%20Rose%20Coeur",
        type: "Pierre roulée"
      },
      pendentif: {
        name: "Collier Naya Quartz Rose",
        url: "https://www.lithae.com/shop/collier-naya-quartz-rose-328",
        imageUrl: "https://www.lithae.com/web/image/product.product/391/image_1024/Collier%20Naya%20Quartz%20Rose",
        type: "Pendentif"
      }
    }
  },
  labradorite: {
    name: "Labradorite",
    shopFilterUrl: "https://www.lithae.com/shop?search=labradorite",
    products: {
      bracelet: {
        name: "Bracelet Labradorite 8mm",
        url: "https://www.lithae.com/shop/bblb8-bracelet-labradorite-8mm-145",
        imageUrl: "https://www.lithae.com/web/image/product.product/171/image_1024/%5BBBLB8%5D%20Bracelet%20Labradorite%208mm",
        type: "Bracelet"
      },
      collier: {
        name: "Collier Doré Labradorite",
        url: "https://www.lithae.com/shop/collier-dore-labradorite-322",
        imageUrl: "https://www.lithae.com/web/image/product.product/381/image_1024/Collier%20Dor%C3%A9%20Labradorite",
        type: "Collier"
      },
      pendentif: {
        name: "Labradorite Pendentif",
        url: "https://www.lithae.com/shop/bplb5-labradorite-pendentif-231",
        imageUrl: "https://www.lithae.com/web/image/product.product/265/image_1024/%5BBPLB5%5D%20Labradorite%20Pendentif",
        type: "Pendentif"
      },
      pierre_roulee: {
        name: "Labradorite Pierre Roulée",
        url: "https://www.lithae.com/shop/pprlb-labradorite-pierre-roulee-182",
        imageUrl: "https://www.lithae.com/web/image/product.product/216/image_1024/%5BPPRLB%5D%20Labradorite%20Pierre%20Roul%C3%A9e",
        type: "Pierre roulée"
      },
      sphere: {
        name: "Labradorite Sphère",
        url: "https://www.lithae.com/shop/labradorite-sphere-198",
        imageUrl: "https://www.lithae.com/web/image/product.product/232/image_1024/Labradorite%20Sph%C3%A8re",
        type: "Sphère"
      },
      a_poser: {
        name: "Labradorite à poser",
        url: "https://www.lithae.com/shop/pplb7-labradorite-a-poser-144",
        imageUrl: "https://www.lithae.com/web/image/product.product/170/image_1024/%5BPPLB7%5D%20Labradorite%20%C3%A0%20poser",
        type: "Pierre décorative"
      },
      galet: {
        name: "Labradorite Galet Plat",
        url: "https://www.lithae.com/shop/ppgplb-labradorite-galet-plat-pour-lithotherapie-183",
        imageUrl: "https://www.lithae.com/web/image/product.product/217/image_1024/%5BPPGPLB%5D%20Labradorite%20Galet%20Plat%20pour%20lithoth%C3%A9rapie",
        type: "Galet"
      }
    }
  },
  "oeil-de-tigre": {
    name: "Œil de Tigre",
    shopFilterUrl: "https://www.lithae.com/shop?search=oeil+tigre",
    products: {
      bracelet: {
        name: "Bracelet Œil de Tigre 8mm",
        url: "https://www.lithae.com/shop/bbot8-bracelet-oeil-de-tigre-8mm-125",
        imageUrl: "https://www.lithae.com/web/image/product.product/151/image_1024/%5BBBOT8%5D%20Bracelet%20Oeil%20de%20tigre%208mm",
        type: "Bracelet"
      },
      collier: {
        name: "Collier Doré Œil de Tigre",
        url: "https://www.lithae.com/shop/collier-dore-oeil-de-tigre-279",
        imageUrl: "https://www.lithae.com/web/image/product.product/338/image_1024/Collier%20Dor%C3%A9%20Oeil%20de%20Tigre",
        type: "Collier"
      },
      pendentif: {
        name: "Œil de Tigre Pendentif",
        url: "https://www.lithae.com/shop/bpot3-oeil-de-tigre-pendentif-233",
        imageUrl: "https://www.lithae.com/web/image/product.product/267/image_1024/%5BBPOT3%5D%20Oeil%20de%20tigre%20Pendentif",
        type: "Pendentif"
      },
      pierre_roulee: {
        name: "Œil de Tigre Pierre Roulée",
        url: "https://www.lithae.com/shop/pprot-oeil-de-tigre-pierre-roulee-180",
        imageUrl: "https://www.lithae.com/web/image/product.product/214/image_1024/%5BPPROT%5D%20Oeil%20de%20tigre%20Pierre%20Roul%C3%A9e",
        type: "Pierre roulée"
      },
      sphere: {
        name: "Œil de Tigre Sphère",
        url: "https://www.lithae.com/shop/ppots1-oeil-de-tigre-sphere-30",
        imageUrl: "https://www.lithae.com/web/image/product.product/32/image_1024/%5BPPOTS1%5D%20Oeil%20de%20tigre%20Sph%C3%A8re",
        type: "Sphère"
      }
    }
  },
  aventurine: {
    name: "Aventurine",
    shopFilterUrl: "https://www.lithae.com/shop?search=aventurine",
    products: {
      bracelet: {
        name: "Bracelet Aventurine 6mm",
        url: "https://www.lithae.com/shop/bbav6-bracelet-aventurine-6mm-134",
        imageUrl: "https://www.lithae.com/web/image/product.product/160/image_1024/%5BBBAV6%5D%20Bracelet%20Aventurine%206mm",
        type: "Bracelet"
      },
      collier: {
        name: "Collier Doré Aventurine",
        url: "https://www.lithae.com/shop/collier-dore-aventurine-309",
        imageUrl: "https://www.lithae.com/web/image/product.product/368/image_1024/Collier%20Dor%C3%A9%20Aventurine",
        type: "Collier"
      },
      pendentif: {
        name: "Collier Naya Aventurine",
        url: "https://www.lithae.com/shop/collier-naya-aventurine-327",
        imageUrl: "https://www.lithae.com/web/image/product.product/390/image_1024/Collier%20Naya%20Aventurine",
        type: "Pendentif"
      },
      pierre_roulee: {
        name: "Aventurine Pierre Roulée",
        url: "https://www.lithae.com/shop/aventurine-pierre-roulee-179",
        imageUrl: "https://www.lithae.com/web/image/product.product/213/image_1024/Aventurine%20Pierre%20Roul%C3%A9e",
        type: "Pierre roulée"
      }
    }
  },
  howlite: {
    name: "Howlite",
    shopFilterUrl: "https://www.lithae.com/shop?search=howlite",
    products: {
      bracelet: {
        name: "Bracelet Howlite 8mm",
        url: "https://www.lithae.com/shop/bbhl8-bracelet-howlite-8mm-234",
        imageUrl: "https://www.lithae.com/web/image/product.product/289/image_1024/%5BBBHL8%5D%20Bracelet%20Howlite%208mm",
        type: "Bracelet"
      },
      collier: {
        name: "Collier Doré Howlite",
        url: "https://www.lithae.com/shop/collier-dore-howlite-276",
        imageUrl: "https://www.lithae.com/web/image/product.product/335/image_1024/Collier%20Dor%C3%A9%20Howlite",
        type: "Collier"
      },
      pendentif: {
        name: "Collier Soléa Howlite",
        url: "https://www.lithae.com/shop/collier-solea-howlite-332",
        imageUrl: "https://www.lithae.com/web/image/product.product/395/image_1024/Collier%20Sol%C3%A9a%20Howlite",
        type: "Pendentif"
      }
    }
  },
  cornaline: {
    name: "Cornaline",
    shopFilterUrl: "https://www.lithae.com/shop?search=cornaline",
    products: {
      bracelet: {
        name: "Bracelet Cornaline 6mm",
        url: "https://www.lithae.com/shop/bracelet-cornaline-6mm-99",
        imageUrl: "https://www.lithae.com/web/image/product.product/101/image_1024/Bracelet%20Cornaline%206mm",
        type: "Bracelet"
      },
      collier: {
        name: "Collier Soléa Cornaline",
        url: "https://www.lithae.com/shop/collier-solea-cornaline-333",
        imageUrl: "https://www.lithae.com/web/image/product.product/396/image_1024/Collier%20Sol%C3%A9a%20Cornaline",
        type: "Collier"
      },
      pierre_roulee: {
        name: "Cornaline Pierre Roulée",
        url: "https://www.lithae.com/shop/pprcn-cornaline-pierre-roulee-188",
        imageUrl: "https://www.lithae.com/web/image/product.product/222/image_1024/%5BPPRCN%5D%20Cornaline%20pierre%20roul%C3%A9e",
        type: "Pierre roulée"
      }
    }
  },
  sodalite: {
    name: "Sodalite",
    shopFilterUrl: "https://www.lithae.com/shop?search=sodalite",
    products: {
      bracelet: {
        name: "Bracelet Sodalite 8mm",
        url: "https://www.lithae.com/shop/bracelet-sodalite-8mm-117",
        imageUrl: "https://www.lithae.com/web/image/product.product/119/image_1024/Bracelet%20Sodalite%208mm",
        type: "Bracelet"
      },
      collier: {
        name: "Collier Doré Anneau Sodalite",
        url: "https://www.lithae.com/shop/bcdsd-collier-dore-anneau-sodalite-258",
        imageUrl: "https://www.lithae.com/web/image/product.product/316/image_1024/%5BBCDSD%5D%20Collier%20Dor%C3%A9%20Anneau%20Sodalite",
        type: "Collier"
      },
      pendentif: {
        name: "Collier Naya Sodalite",
        url: "https://www.lithae.com/shop/collier-naya-sodalite-329",
        imageUrl: "https://www.lithae.com/web/image/product.product/392/image_1024/Collier%20Naya%20Sodalite",
        type: "Pendentif"
      },
      pierre_roulee: {
        name: "Sodalite Pierre Roulée",
        url: "https://www.lithae.com/shop/pprsd-sodalite-pierre-roulee-227",
        imageUrl: "https://www.lithae.com/web/image/product.product/261/image_1024/%5BPPRSD%5D%20Sodalite%20Pierre%20Roul%C3%A9e",
        type: "Pierre roulée"
      }
    }
  },
  "cristal-de-roche": {
    name: "Cristal de Roche",
    shopFilterUrl: "https://www.lithae.com/shop?search=cristal+de+roche",
    products: {
      bracelet: {
        name: "Bracelet Cristal de Roche 6mm",
        url: "https://www.lithae.com/shop/bracelet-en-cristal-de-roche-6mm-295",
        imageUrl: "https://www.lithae.com/web/image/product.product/354/image_1024/Bracelet%20en%20Cristal%20de%20Roche%206MM",
        type: "Bracelet"
      },
      collier: {
        name: "Collier Doré Cristal de Roche",
        url: "https://www.lithae.com/shop/collier-dore-cristal-de-roche-310",
        imageUrl: "https://www.lithae.com/web/image/product.product/369/image_1024/Collier%20Dor%C3%A9%20Cristal%20de%20Roche",
        type: "Collier"
      },
      pendentif: {
        name: "Collier Soléa Cristal de Roche",
        url: "https://www.lithae.com/shop/collier-solea-cristal-de-roche-330",
        imageUrl: "https://www.lithae.com/web/image/product.product/393/image_1024/Collier%20Sol%C3%A9a%20Cristal%20de%20Roche",
        type: "Pendentif"
      },
      pierre_roulee: {
        name: "Cristal de Roche Pierre Roulée",
        url: "https://www.lithae.com/shop/cristal-de-roche-pierre-roulee-289",
        imageUrl: "https://www.lithae.com/web/image/product.product/348/image_1024/Cristal%20de%20Roche%20Pierre%20Roul%C3%A9e",
        type: "Pierre roulée"
      },
      galet: {
        name: "Galet Plat Cristal de Roche",
        url: "https://www.lithae.com/shop/galet-plat-cristal-de-roche-296",
        imageUrl: "https://www.lithae.com/web/image/product.product/355/image_1024/Galet%20Plat%20Cristal%20de%20Roche",
        type: "Galet"
      },
      geode: {
        name: "Géode de Cristal de Roche",
        url: "https://www.lithae.com/shop/pbgcr10-geode-de-cristal-de-roche-307",
        imageUrl: "https://www.lithae.com/web/image/product.product/366/image_1024/%5BPBGCR10%5D%20G%C3%A9ode%20de%20Cristal%20de%20Roche",
        type: "Géode"
      },
      pointe: {
        name: "Pointe en Cristal de Roche",
        url: "https://www.lithae.com/shop/pppcr5-pointe-en-cristal-de-roche-294",
        imageUrl: "https://www.lithae.com/web/image/product.product/353/image_1024/%5BPPPCR5%5D%20Pointe%20en%20Cristal%20de%20Roche",
        type: "Pointe"
      }
    }
  },
  obsidienne: {
    name: "Obsidienne",
    shopFilterUrl: "https://www.lithae.com/shop?search=obsidienne",
    products: {
      bracelet: {
        name: "Bracelet Obsidienne 6mm",
        url: "https://www.lithae.com/shop/bbos6-bracelet-obsidiene-6mm-111",
        imageUrl: "https://www.lithae.com/web/image/product.product/113/image_1024/%5BBBOS6%5D%20Bracelet%20Obsidiene%206mm",
        type: "Bracelet"
      }
    }
  },
  "pierre-de-lune": {
    name: "Pierre de Lune",
    shopFilterUrl: "https://www.lithae.com/shop?search=pierre+de+lune",
    products: {
      bracelet: {
        name: "Bracelet Pierre de Lune 6mm",
        url: "https://www.lithae.com/shop/bracelet-pierre-de-lune-6mm-114",
        imageUrl: "https://www.lithae.com/web/image/product.product/287/image_1024/Bracelet%20Pierre%20de%20Lune%206mm",
        type: "Bracelet"
      }
    }
  },
  "jaspe-mookaite": {
    name: "Jaspe Mokaïte",
    shopFilterUrl: "https://www.lithae.com/shop?search=jaspe+mokaite",
    products: {
      bracelet: {
        name: "Bracelet Jaspe Mokaïte 6mm",
        url: "https://www.lithae.com/shop/bracelet-jaspe-mokaite-6mm-104",
        imageUrl: "https://www.lithae.com/web/image/product.product/322/image_1024/Bracelet%20Jaspe%20Moka%C3%AFte%206mm",
        type: "Bracelet"
      }
    }
  },
  "jaspe-rouge": {
    name: "Jaspe Rouge",
    shopFilterUrl: "https://www.lithae.com/shop?search=jaspe+rouge",
    products: {
      bracelet: {
        name: "Bracelet Jaspe Rouge 6mm",
        url: "https://www.lithae.com/shop/bbjr6-bracelet-jaspe-rouge-6mm-105",
        imageUrl: "https://www.lithae.com/web/image/product.product/107/image_1024/%5BBBJR6%5D%20Bracelet%20Jaspe%20Rouge%206mm",
        type: "Bracelet"
      }
    }
  },
  "jaspe-unakite": {
    name: "Jaspe Unakite",
    shopFilterUrl: "https://www.lithae.com/shop?search=jaspe+unakite",
    products: {
      bracelet: {
        name: "Bracelet Jaspe Unakite 8mm",
        url: "https://www.lithae.com/shop/bbju8-bracelet-jaspe-unakite-8mm-235",
        imageUrl: "https://www.lithae.com/web/image/product.product/292/image_1024/%5BBBJU8%5D%20Bracelet%20Jaspe%20Unakite%208mm",
        type: "Bracelet"
      }
    }
  },
  "agate-mousse": {
    name: "Agate Mousse",
    shopFilterUrl: "https://www.lithae.com/shop?search=agate+mousse",
    products: {
      bracelet: {
        name: "Bracelet Agate Mousse 8mm",
        url: "https://www.lithae.com/shop/bbam8-bracelet-agate-mousse-8mm-95",
        imageUrl: "https://www.lithae.com/web/image/product.product/97/image_1024/%5BBBAM8%5D%20Bracelet%20Agate%20Mousse%208mm",
        type: "Bracelet"
      }
    }
  },
  "lapis-lazuli": {
    name: "Lapis Lazuli",
    shopFilterUrl: "https://www.lithae.com/shop?search=lapis+lazuli",
    products: {
      bracelet: {
        name: "Bracelet Lapis Lazuli 8mm",
        url: "https://www.lithae.com/shop/bbll8-bracelet-lapis-lazuli-8mm-109",
        imageUrl: "https://www.lithae.com/web/image/product.product/111/image_1024/%5BBBLL8%5D%20Bracelet%20Lapis%20Lazuli%208mm",
        type: "Bracelet"
      },
      pierre_roulee: {
        name: "Lapis Lazuli Pierre Roulée",
        url: "https://www.lithae.com/shop/pprll-lapis-lazuli-pierre-roulee-184",
        imageUrl: "https://www.lithae.com/web/image/product.product/218/image_1024/%5BPPRLL%5D%20Lapis%20Lazuli%20Pierre%20Roul%C3%A9e",
        type: "Pierre roulée"
      }
    }
  },
  fluorite: {
    name: "Fluorite",
    shopFilterUrl: "https://www.lithae.com/shop?search=fluorite",
    products: {
      bracelet: {
        name: "Bracelet Fluorite 6mm",
        url: "https://www.lithae.com/shop/bracelet-fluorite-6mm-101",
        imageUrl: "https://www.lithae.com/web/image/product.product/273/image_1024/Bracelet%20Fluorite%206mm",
        type: "Bracelet"
      },
      sphere: {
        name: "Sphère Fluorite",
        url: "https://www.lithae.com/shop/ppsfr2-sphere-fluorite-195",
        imageUrl: "https://www.lithae.com/web/image/product.product/229/image_1024/%5BPPSFR2%5D%20Sph%C3%A8re%20Fluorite",
        type: "Sphère"
      }
    }
  },
  hematite: {
    name: "Hématite",
    shopFilterUrl: "https://www.lithae.com/shop?search=hematite",
    products: {
      bracelet: {
        name: "Bracelet Hématite 6mm",
        url: "https://www.lithae.com/shop/bracelet-hematite-6mm-100",
        imageUrl: "https://www.lithae.com/web/image/product.product/276/image_1024/Bracelet%20Hematite%206mm",
        type: "Bracelet"
      }
    }
  },
  malachite: {
    name: "Malachite",
    shopFilterUrl: "https://www.lithae.com/shop?search=malachite",
    products: {
      bracelet: {
        name: "Bracelet Malachite 6mm",
        url: "https://www.lithae.com/shop/bbml6-bracelet-malachite-6mm-110",
        imageUrl: "https://www.lithae.com/web/image/product.product/112/image_1024/%5BBBML6%5D%20Bracelet%20Malachite%206mm",
        type: "Bracelet"
      },
      pierre_roulee: {
        name: "Malachite Pierre Roulée",
        url: "https://www.lithae.com/shop/pprml-malachite-pierre-roulee-177",
        imageUrl: "https://www.lithae.com/web/image/product.product/211/image_1024/%5BPPRML%5D%20Malachite%20Pierre%20Roul%C3%A9e",
        type: "Pierre roulée"
      },
      a_poser: {
        name: "Malachite Plaque",
        url: "https://www.lithae.com/shop/pppml6-malachite-plaque-92",
        imageUrl: "https://www.lithae.com/web/image/product.product/94/image_1024/%5BPPPML6%5D%20Malachite%20Plaque",
        type: "Plaque"
      }
    }
  },
  pyrite: {
    name: "Pyrite",
    shopFilterUrl: "https://www.lithae.com/shop?search=pyrite",
    products: {
      pierre_brute: {
        name: "Pyrite Brute",
        url: "https://www.lithae.com/shop/pbpr2-pyrite-brute-29",
        imageUrl: "https://www.lithae.com/web/image/product.product/31/image_1024/%5BPBPR2%5D%20Pyrite%20Brute",
        type: "Pierre brute"
      },
      coeur: {
        name: "Pyrite Cœur",
        url: "https://www.lithae.com/shop/ppcpr1-pyrite-coeur-216",
        imageUrl: "https://www.lithae.com/web/image/product.product/250/image_1024/%5BPPCPR1%5D%20Pyrite%20Coeur",
        type: "Cœur"
      },
      pierre_roulee: {
        name: "Pyrite Pierres Roulées",
        url: "https://www.lithae.com/shop/pprpr-pyrite-pierres-roulees-205",
        imageUrl: "https://www.lithae.com/web/image/product.product/239/image_1024/%5BPPRPR%5D%20Pyrite%20Pierres%20Roul%C3%A9es",
        type: "Pierre roulée"
      },
      sphere: {
        name: "Pyrite Sphère",
        url: "https://www.lithae.com/shop/ppspr1-pyrite-sphere-221",
        imageUrl: "https://www.lithae.com/web/image/product.product/255/image_1024/%5BPPSPR1%5D%20Pyrite%20Sph%C3%A8re",
        type: "Sphère"
      }
    }
  },
  rhodonite: {
    name: "Rhodonite",
    shopFilterUrl: "https://www.lithae.com/shop?search=rhodonite",
    products: {
      bracelet: {
        name: "Bracelet Rhodonite 8mm",
        url: "https://www.lithae.com/shop/bbrd8-bracelet-rhodonite-8mm-225",
        imageUrl: "https://www.lithae.com/web/image/product.product/259/image_1024/%5BBBRD8%5D%20Bracelet%20Rhodonite%208mm",
        type: "Bracelet"
      }
    }
  },
  calcedoine: {
    name: "Calcédoine",
    shopFilterUrl: "https://www.lithae.com/shop?search=calcedoine",
    products: {
      pierre_roulee: {
        name: "Calcédoine Pierre Roulée",
        url: "https://www.lithae.com/shop/prcc22-calcedoine-pierre-roulee-87",
        imageUrl: "https://www.lithae.com/web/image/product.product/89/image_1024/%5BPRCC22%5D%20Calc%C3%A9doine%20Pierre%20Roul%C3%A9e",
        type: "Pierre roulée"
      }
    }
  },
  apatite: {
    name: "Apatite",
    shopFilterUrl: "https://www.lithae.com/shop?search=apatite",
    products: {
      bracelet: {
        name: "Bracelet Apatite 6mm",
        url: "https://www.lithae.com/shop/bbap6-bracelet-apatite-6mm-98",
        imageUrl: "https://www.lithae.com/web/image/product.product/100/image_1024/%5BBBAP6%5D%20Bracelet%20Apatite%206mm",
        type: "Bracelet"
      },
      galet: {
        name: "Apatite Galet Plat",
        url: "https://www.lithae.com/shop/apatite-galet-plat-pour-lithotherapie-178",
        imageUrl: "https://www.lithae.com/web/image/product.product/212/image_1024/Apatite%20Galet%20Plat%20pour%20lithoth%C3%A9rapie",
        type: "Galet"
      }
    }
  },
  "bois-fossile": {
    name: "Bois Fossile",
    shopFilterUrl: "https://www.lithae.com/shop?search=bois+fossile",
    products: {
      bracelet: {
        name: "Bois Fossile Bracelet 8mm",
        url: "https://www.lithae.com/shop/bbbf8-bois-fossile-bracelet-8mm-223",
        imageUrl: "https://www.lithae.com/web/image/product.product/257/image_1024/%5BBBBF8%5D%20Bois%20Fossile%20Bracelet%208mm",
        type: "Bracelet"
      },
      galet: {
        name: "Bois Fossile Galet Plat",
        url: "https://www.lithae.com/shop/ppgpbf-bois-fossile-galet-plat-pour-lithotherapie-181",
        imageUrl: "https://www.lithae.com/web/image/product.product/215/image_1024/%5BPPGPBF%5D%20Bois%20Fossile%20Galet%20Plat%20pour%20lithoth%C3%A9rapie",
        type: "Galet"
      },
      a_poser: {
        name: "Bois Fossile Plaque",
        url: "https://www.lithae.com/shop/pppbf3-bois-fossile-plaque-65",
        imageUrl: "https://www.lithae.com/web/image/product.product/193/image_1024/%5BPPPBF3%5D%20Bois%20Fossile%20Plaque",
        type: "Plaque"
      }
    }
  },
  septaria: {
    name: "Septaria",
    shopFilterUrl: "https://www.lithae.com/shop?search=septaria",
    products: {
      geode: {
        name: "Géode de Septaria",
        url: "https://www.lithae.com/shop/pgse1-geode-de-septaria-17",
        imageUrl: "https://www.lithae.com/web/image/product.product/17/image_1024/%5BPGSE1%5D%20G%C3%A9ode%20de%20septaria",
        type: "Géode"
      }
    }
  }
};

/**
 * Get product suggestions for a stone based on user's usage preference
 * Only returns suggestions if real products are defined for this stone
 * @param {string} stoneId - The stone ID
 * @param {string} usage - The user's usage preference
 * @param {Object} stone - The stone object (unused, kept for compatibility)
 * @returns {Object|null} Product suggestions or null if no products defined
 */
export const getProductSuggestions = (stoneId, usage, stone = null) => {
  const stoneProducts = STONE_PRODUCTS[stoneId];
  
  // Only show suggestions if real products are defined for this stone
  if (!stoneProducts) {
    return null;
  }

  const usageConfig = PRODUCT_TYPES[usage] || PRODUCT_TYPES.sur_soi;
  const suggestions = [];

  // Get products matching the usage categories
  for (const category of usageConfig.categories) {
    if (stoneProducts.products[category]) {
      suggestions.push({
        ...stoneProducts.products[category],
        category
      });
    }
    if (suggestions.length >= 3) break;
  }

  // If not enough products, add from other categories
  if (suggestions.length < 2) {
    const allCategories = Object.keys(stoneProducts.products);
    for (const category of allCategories) {
      if (!suggestions.find(s => s.category === category)) {
        suggestions.push({
          ...stoneProducts.products[category],
          category
        });
      }
      if (suggestions.length >= 3) break;
    }
  }

  return {
    stoneName: stoneProducts.name,
    shopUrl: stoneProducts.shopFilterUrl,
    usageLabel: usageConfig.label,
    usageDescription: usageConfig.description,
    products: suggestions
  };
};

export default { PRODUCT_TYPES, STONE_PRODUCTS, getProductSuggestions };
